import { render } from "./_users-category.vue?vue&type=template&id=d21df11e&scoped=true&lang=pug"
import script from "./_users-category.vue?vue&type=script&lang=js"
export * from "./_users-category.vue?vue&type=script&lang=js"

import "./_users-category.vue?vue&type=style&index=0&id=d21df11e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d21df11e"]])

export default __exports__